// Saisie au clavier dans un tableau de séries (travail ou échauffement) :
// Entrée passe des reps à la charge, puis aux reps de la ligne suivante ; sur
// la dernière ligne, Entrée ajoute une ligne (pré-remplie par l'appelant) et y
// place le curseur. Le contenu d'un champ est sélectionné à l'arrivée, pour
// que la frappe remplace la valeur au lieu de s'y ajouter.
import { useEffect, useRef } from "react";

export default function useSaisieClavier(nombreLignes, onAjouter) {
	const champs = useRef({});
	const focusApresAjout = useRef(false);

	const placer = (index, champ) => {
		const champSaisi = champs.current[`${index}-${champ}`];
		if (!champSaisi) return;
		champSaisi.focus();
		champSaisi.select();
	};

	// La ligne ajoutée par Entrée n'existe qu'au rendu suivant.
	useEffect(() => {
		if (!focusApresAjout.current) return;
		focusApresAjout.current = false;
		const champSaisi = champs.current[`${nombreLignes - 1}-reps`];
		champSaisi?.focus();
		champSaisi?.select();
	}, [nombreLignes]);

	const refChamp = (index, champ) => (element) => {
		champs.current[`${index}-${champ}`] = element;
	};

	const surTouche = (index, champ) => (e) => {
		if (e.key !== "Enter") return;
		e.preventDefault();
		if (champ === "reps") placer(index, "poids");
		else if (index < nombreLignes - 1) placer(index + 1, "reps");
		else {
			focusApresAjout.current = true;
			onAjouter?.();
		}
	};

	const toutSelectionner = (e) => e.target.select();

	return { refChamp, surTouche, toutSelectionner };
}
